<template>
  <div>
    <PPrimaryButton appkit-icon="icon-plus-fill" @click="open"
      >Add Supplier</PPrimaryButton
    >
    <SupplierDialog
      :open-dialog="isDialogOpen"
      :can-upload-business-partner="canUploadBusinessPartner"
      @close-dialog="close"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import SupplierDialog from "@/views/supplier-registry/SupplierDialog.vue";
import { ref } from "vue";

const emits = defineEmits<{
  (e: "supplierAdded"): void;
}>();

const props = defineProps<{
  canUploadBusinessPartner: boolean;
}>();

const isDialogOpen = ref(false);

const open = () => (isDialogOpen.value = true);
const close = () => (isDialogOpen.value = false);

function onChange(): void {
  emits("supplierAdded");
  close();
}
</script>
